module.exports = __webpack_public_path__ + "assets/img/WenJ.7124eba5.png";